import { apiFetch } from "./apiFetch";
import { getApiErrorMessage, normalizeFetchError } from "./apiError";
import type {
  WorkflowDecision,
  WorkflowDecisionResult,
  WorkflowHistoryResponse,
  WorkflowState,
} from "../types/workflow";

const API_URL = process.env.REACT_APP_API_URL;

export async function getDocumentWorkflow(
  companyId: string,
  documentId: string
): Promise<WorkflowState> {
  const params = new URLSearchParams();
  params.set("companyId", companyId);

  const res = await apiFetch(
    `${API_URL}/documents/${documentId}/workflow?${params.toString()}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(
        res,
        "Nie udało się pobrać stanu workflow akceptacji."
      )
    );
  }

  return res.json() as Promise<WorkflowState>;
}

export async function getDocumentWorkflowHistory(
  companyId: string,
  documentId: string
): Promise<WorkflowHistoryResponse> {
  const params = new URLSearchParams();
  params.set("companyId", companyId);

  const res = await apiFetch(
    `${API_URL}/documents/${documentId}/workflow/history?${params.toString()}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(
        res,
        "Nie udało się pobrać historii workflow."
      )
    );
  }

  return res.json() as Promise<WorkflowHistoryResponse>;
}

export async function proceedDocumentWorkflow(
  companyId: string,
  documentId: string,
  decision: WorkflowDecision,
  comment = ""
): Promise<WorkflowDecisionResult> {
  const params = new URLSearchParams();
  params.set("companyId", companyId);

  try {
    const res = await apiFetch(
      `${API_URL}/documents/${documentId}/workflow/decision?${params.toString()}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ decision, comment }),
      }
    );

    if (!res.ok) {
      throw new Error(
        await getApiErrorMessage(
          res,
          "Nie udało się wykonać decyzji workflow."
        )
      );
    }

    return res.json() as Promise<WorkflowDecisionResult>;
  } catch (error) {
    throw normalizeFetchError(
      error,
      "Nie udało się wykonać decyzji workflow."
    );
  }
}
